<template>
  <div class="c-section-header">
    <h2 class="c-section-header__title">{{ title }}</h2>
    <div class="c-section-header__description">
      <p>{{ desc }}</p>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      desc: {
        required: true,
        type: String,
      },
      title: {
        required: true,
        type: String,
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/components/consumer/report-a-problem/_vue/SectionHeader.vue